import { takeLatest, put, call } from 'redux-saga/effects';
import { actionTypes as applicationActions } from '../core/reducers/asyncServerResponseReducer';
import { historyResponseService } from './../gameservice/historyResponseService';

export function* historySaga(): Generator<any, any, any> {
  yield takeLatest(applicationActions.GET_APPLICATION_HISTORY_RESPONSE, fireHistoryResponse);
  yield takeLatest(applicationActions.GET_APPLICATION_SPECIFIC_HISTORY_RESPONSE, fireHistorySpecificResponse);
}



let spincount: number = 0
function* fireHistoryResponse(): Generator<any, any, any> {
  try {
 
    let result_spin = yield call(historyResponseService.sendhistoryResponse);  
    result_spin =  result_spin.data;
    //localStorage.setItem("cheatModifiedRequest", "")
    yield put({
      type: applicationActions.GET_APPLICATION_HISTORY_SUCCESS,
      result_spin
    });

  } catch (error) {
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_FAILURE,
      error
    });
  }
}
function* fireHistorySpecificResponse(): Generator<any, any, any> {
  try {
 
    let result_spin = yield call(historyResponseService.sendhistorySpecificResponse);  

    //localStorage.setItem("cheatModifiedRequest", "")
    yield put({
      type: applicationActions.GET_APPLICATION_HISTORY_SUCCESS,
      result_spin
    });

  } catch (error) {
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_FAILURE,
      error
    });
  }
}

